import { render } from "./SavoirsFaire.vue?vue&type=template&id=5dbae02c&scoped=true"
import script from "./SavoirsFaire.vue?vue&type=script&lang=js"
export * from "./SavoirsFaire.vue?vue&type=script&lang=js"

import "./SavoirsFaire.vue?vue&type=style&index=0&id=5dbae02c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbae02c"]])

export default __exports__